ready(() => {

    // Content Blocker
    (function() {
        var iframes = [];
        function showBlockedIframe(blockedIframe) {
            var iframe = document.createElement('iframe');
            var attrs = Array.from(blockedIframe.attributes);

            attrs.forEach(function(attr) {
                iframe.setAttribute(attr.name, attr.value);
            });

            blockedIframe.parentNode.replaceChild(iframe, blockedIframe);
            iframes.push(iframe);
        }

        // get domain from url. ignore subdomains
        function getDomainFromBlockedIframe(blockedIframe) {
            var src = blockedIframe.getAttribute('src');
            var url = new URL(src);
            var hostnameParts = url.hostname.split('.');
            if (hostnameParts.length > 2) {
                hostnameParts.shift();
                url.hostname = hostnameParts.join('.');
            }
            return url.hostname;

        }
        var blockedIframes = findAll('blocked-iframe');

        blockedIframes.forEach(function(blockedIframe) {

            var domain = getDomainFromBlockedIframe(blockedIframe);

            // show iframe content
            if (Cookies.get('always-load-external-iframe-' + domain) === 1) {
                showBlockedIframe(blockedIframe);

                // or create acceptance message
            } else {
                var uid = "always-load-external-" + domain + "-" + (Math.floor(Math.random() * 10000));

                const width = blockedIframe.getAttribute('width');
                const height = blockedIframe.getAttribute('height');

                const iframeBlockerHTML = `
                  <div class="iframe-blocker" style="width: ${width}px; height: ${height}px">
                    <div class="container">
                      <div class="message">Inhalt von ${domain} laden? Dabei werden potenziell Cookies gesetzt und Daten in die USA übertragen.</div>
                      <a href="#" class="button">Video laden</a>
                      <div class="checkbox">
                        <input type="checkbox" id="${uid}" name="always-load-external">
                        <label for="${uid}">Inhalt von ${domain} immer laden</label>
                      </div>
                    </div>
                  </div>
                `;

                blockedIframe.insertAdjacentHTML('afterend', iframeBlockerHTML);
            }

        });

        document.addEventListener('click', function(ev) {
            const target = ev.target;

            if (target.classList.contains('button') && target.closest('.iframe-blocker')) {
                const iframeBlocker = target.closest('.iframe-blocker');
                const alwaysLoadExternal = iframeBlocker.querySelector('.checkbox input').checked;

                var domain = getDomainFromBlockedIframe(iframeBlocker.previousElementSibling);

                // show all blocked iframes for this domain and remember this?
                if (alwaysLoadExternal) {
                    setCookie('always-load-external-iframe-' + domain, 1);

                    const allIframeBlockers = document.querySelectorAll('.iframe-blocker');
                    allIframeBlockers.forEach(function(blocker) {
                        const prevElement = blocker.previousElementSibling;
                        var thisDomain = getDomainFromBlockedIframe(prevElement);
                        if (thisDomain === domain) {
                            blocker.remove()
                            showBlockedIframe(prevElement);
                        }
                    });

                } else {
                    const prevElement = iframeBlocker.previousElementSibling;
                    showBlockedIframe(prevElement);
                    iframeBlocker.remove();
                }

                ev.preventDefault();
            }

        });
    })();
});